<template>
  <span class="badge" :class="getBadgeClass(status)">
    {{ formatStatus(status) }}
  </span>
</template>

<script>
export default {
  name: "SessionStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ["SCHEDULED", "VERIFIED"].includes(value),
    },
  },
  methods: {
    formatStatus(status) {
      const statusMap = {
        SCHEDULED: "Scheduled",
        VERIFIED: "Verified",
      };
      return statusMap[status] || status;
    },
    getBadgeClass(status) {
      const classMap = {
        SCHEDULED: "badge-primary",
        VERIFIED: "badge-deep-success",
      };
      return classMap[status] || "badge-secondary";
    },
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}
</style>
